import { updateState } from "../helpers/functions"

const valueReducer = (state, action) => {
    switch (action.type) {
        case "name": return updateState(state, "name", action.payload)
        case "value": return updateState(state, "value",  Math.abs(Number(action.payload)))
        default: return state
    }
}

export default valueReducer